import React from "react"
import PropTypes from "prop-types"

import FilterRow from "./FilterRow/index.jsx"

export default function VenueFeaturesChooser(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { selectedFeatures = {}, onFeatureSelected } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // -------------------------------------

  return (
    <div>
      {Object.entries(selectedFeatures).map(([name, selected]) => {
        return (
          <FilterRow
            name={name}
            key={name}
            label={I18n.t(`pages.locations.venues.features.${name}`)}
            selected={selected === true}
            onSelect={onFeatureSelected}
          />
        )
      })}
    </div>
  )
}

VenueFeaturesChooser.propTypes = {
  selectedFeatures: PropTypes.object.isRequired,
  onFeatureSelected: PropTypes.func.isRequired,
}
